module.exports = __webpack_public_path__ + "media/images/gift/steps/concierge-bbafb9fc800c8074778612ba3787b5ef.png";